import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@mui/styles";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Tooltip from "@mui/material/Tooltip";
import "react-daterange-picker/dist/css/react-calendar.css";
import spinner from '../../assign-prescriptions/images/spinner.gif';
import moment from 'moment-timezone';
import {withTranslation} from "react-i18next";
import ILocalAGGrid, {
  getDefaultColDef,
  createServerSideDatasource,
  withDateColumnFilter,
  applyReportFilterModel,
  attachReportServerSideDatasource,
  PHARMACY_REPORT_SORT_MAP,
} from "../../grid/iLocalAGGrid";
import {getDefaultDateRange, getDateRangeByPreset, formatFromDateForAPI, formatToDateForAPI} from "../../../utils/datetime.utils";
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";

class EnhancedTableHead extends React.Component {
    render() {
        const {order, orderBy, sortId, t} = this.props;
        const rows = [
            { id: "store_name", numeric: false, disablePadding: false, label: t("Report.phiLogs.Store"), padding: '10px', field: 'store_name' },
            { id: "operation", numeric: false, disablePadding: false, label: t("Report.purgeTrail.Operation"), padding: '10px', field: 'operation' },
            { id: "purge_success_s3_count", numeric: false, disablePadding: false, label: t("Report.purgeTrail.TotalPassedDeletion"), padding: '10px', field: 'purge_success_s3_count' },
            { id: "purge_failed_s3_count", numeric: false, disablePadding: false, label: t("Report.purgeTrail.TotalFailedDeletion"), padding: '10px', field: 'purge_failed_s3_count' },
            { id: "purge_success_db_count", numeric: false, disablePadding: false, label: t("Report.purgeTrail.TotalPassedupdation"), padding: '10px', field: 'purge_success_db_count' },
            { id: "purge_failed_db_count", numeric: false, disablePadding: false, label: t("Report.purgeTrail.TotalFailedupdation"), padding: '10px', field: 'purge_failed_db_count' },
            { id: "total_processed_images", numeric: false, disablePadding: false, label: t("Report.purgeTrail.TotalProcessedEntries"), padding: '10px', field: 'total_processed_images' },
            { id: "purge_status", numeric: false, disablePadding: false, label: t("Report.purgeTrail.Status"), padding: '10px', field: 'purge_status' },
            { id: "executaton_date", numeric: false, disablePadding: false, label: t("Report.purgeTrail.ExecutionDate"), padding: '10px', field: 'executaton_date' },
        ];

        return (
            <TableHead>
                <TableRow>
                    {rows.map(row => {
                        return (
                            <TableCell
                                key={row.id}
                                numeric={row.numeric}
                                padding={row.disablePadding ? "none" : "default"}
                                sortDirection={orderBy === row.id ? order : false}
                                style={{ padding: row.padding, color: 'rgba(0, 0, 0, 0.54)' }}
                            >
                                {(
                                    <Tooltip
                                        title={t("Global.Label.Filter.Sort")}
                                        placement={row.numeric ? "bottom-end" : "bottom-start"}
                                        enterDelay={300}
                                    >
                                        <TableSortLabel
                                            active={orderBy === row.field && sortId === row.id}
                                            direction={order}
                                        >
                                            {row.label}
                                        </TableSortLabel>
                                    </Tooltip>
                                )}
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    sortId: PropTypes.string.isRequired
};
EnhancedTableHead = withTranslation()(EnhancedTableHead)

const styles = theme => ({
    table: {
        minWidth: 1020
    },
    tableWrapper: {
        overflowX: "auto"
    },
    dob: {
        paddingTop: '25px',
    },
    headerdiv: {
        paddingLeft: '15%',
        paddingTop: '10'
    }
    ,
    padding10px: {
        padding: '8px'
    }
    , formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        maxWidth: 390,
    },
    logoWrapper:
    {
        position: 'absolute',
        width: '89%',
        height: '70%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'rgba(255,255,255,0.5)',
        zIndex: '7869'
    },
    spinner: {
        position: 'absolute',
        background: 'rgba(255,255,255,.4)',
        width: '100%',
        height: '100%',
        zIndex: '9999',
        top: 0,
        left: 0,
    },
    spinnerImage: {
        top: 'calc(50% - 32.5px)',
        left: 'calc(50% - 65px)',
        position: 'absolute',
        width: '130px',
        userSelect: 'none'
    },
    hidden: {
        display: 'none'
    }

});

let TransactionFilterObj = {
  searchObject: null,
    searchtext: '',
    fromdate: '',
    todate: '',
    pageNo: 0,
    pageSize: 10}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class PurgeTrailComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            order: "desc",
            dob: '',
            orderBy: "created_on",
            page: 0,
            rowsPerPage: 10,
            searchtext: '',
            store_id: [],
            box_id: [],
            fromdate: null,
            todate: null,
            dateRangePreset: 'last7days',
            isOpen: false,
            stores: [],
            boxes: [],
            boxvalues: [],
            accountValues: [],
            nstores: [],
            nboxes: [],
            chipstores: [],
            chipboxes: [],
            loader: false,
            isDataEmpty: true,
            totalRecords: 0,
            isButtonDisabled: false,
            locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale,
            isError: false,
            errorMessage: '',
            queryId: "",
            groups: [],
        };
        this.debouceTimeout = null;
    }

    componentDidMount() {
        // Set default date range (T-30 days to today)
        const defaultDates = getDefaultDateRange();
        this.setState({ 
            fromdate: defaultDates.fromDate,
            todate: defaultDates.toDate,
            dateRangePreset: 'last7days'
        });

        Object.assign(TransactionFilterObj, {
            searchtext: '',
            fromdate: formatFromDateForAPI(defaultDates.fromDate),
            todate: formatToDateForAPI(defaultDates.toDate),
            pageNo: 0,
            pageSize: 10});
        this.setState({ loader: true });
        this.fetchSuggestions();
}

    convertToTimeZone = (requestDate) => {
        const currentUserLang = localStorage.getItem('i18nextLng');
        let zone;
        zone = sessionStorage.getItem('timeZone');
        const date = moment(new Date(requestDate));
        if (['null', null, 'undefined', undefined].includes(zone)) {
            zone = defaultZone;
        }
        return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
    }
    handleChangePage = (event, page) => {
        event && event.preventDefault();
        
        TransactionFilterObj.pageNo = page;
        if (this.state.data && this.state.data.length > 0) {
            this.BindGrid();
        }
    };

    handleChangeRowsPerPage = event => {
        
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.pageSize = event.target.value;
        if (this.state.data && this.state.data.length > 0) {
            this.BindGrid();
        }
    };

    //Search Text Box change event
    onSearchChange = (event) => {
        this.debouceTimeout && clearInterval(this.debouceTimeout);
        const searchString = event.target.value;
        this.setState({ searchtext: searchString && searchString });
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.searchtext = searchString;
        this.debouceTimeout = setTimeout(() => {
            this.BindGrid();
        }, 1000)
    }

    onFromDateSelect = date => {
        const dateObj = date ? moment(date) : null;
        this.setState({ fromdate: dateObj, dateRangePreset: '' });
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.fromdate = formatFromDateForAPI(dateObj);
        this.BindGrid();
    };

    onToDateSelect = date => {
        const dateObj = date ? moment(date) : null;
        this.setState({ todate: dateObj, dateRangePreset: '' });
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.todate = formatToDateForAPI(dateObj);
        this.setState({ loader: true })
        this.BindGrid();
    };

    handleBlurfrom = (value, date) => {
        const dateObj = date ? moment(date) : null;
        this.setState({
            fromdate: dateObj,
            dateRangePreset: ''
        });
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.fromdate = formatFromDateForAPI(dateObj);
        this.BindGrid();
    }

    handleBlurtodate = (value, date) => {
        const dateObj = date ? moment(date) : null;
        this.setState({
            todate: dateObj,
            dateRangePreset: ''
        });
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.todate = formatToDateForAPI(dateObj);
        this.BindGrid();
    }
    
    handleDateRangePresetChange = (event) => {
        const preset = event.target.value;
        if (!preset) return;
        
        const dateRange = getDateRangeByPreset(preset);
        this.setState({
            fromdate: dateRange.fromDate,
            todate: dateRange.toDate,
            dateRangePreset: preset
        });
        
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.fromdate = formatFromDateForAPI(dateRange.fromDate);
        TransactionFilterObj.todate = formatToDateForAPI(dateRange.toDate);
        this.BindGrid();
    };

  
  refreshGrid = () => {
    if (!this.gridApi) return;
    if (typeof this.gridApi.refreshServerSideStore === "function") {
      this.gridApi.refreshServerSideStore({ purge: true });
    } else if (typeof this.gridApi.refreshServerSide === "function") {
      this.gridApi.refreshServerSide({ purge: true });
    }
  };

  onPaginationChanged = (params) => {
    if (!params.api) return;
    const newPageSize = params.api.paginationGetPageSize();
    if (newPageSize && TransactionFilterObj.pageSize !== newPageSize) {
      TransactionFilterObj.pageSize = newPageSize;
    }
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    const datasource = createServerSideDatasource({
      sortMap: PHARMACY_REPORT_SORT_MAP,
      filterBody: TransactionFilterObj,
      applyFilterModel: (body, filterModel) => {
        applyReportFilterModel(body, filterModel, { dateColIds: ['executaton_date'] });
      },
      pageZeroBased: true,
      getPageSize: () => TransactionFilterObj.pageSize || 10,
      fetchPage: (body) =>
        fetch(process.env.REACT_APP_BASEURL + "purge/patients/pictures/purge-trail", {
          method: "post",
          withCredentials: true,
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user")).signInUserSession
                .idToken.jwtToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        })
          .then((r) => r.json())
          .then((data) => {
            if (data && data.results) return data;
            if (data && data.data && data.data.results) {
              return { results: data.data.results, total: data.data.total };
            }
            if (Array.isArray(data)) return { results: data, total: data.length };
            return {
              results: (data && (data.rows || data.data)) || [],
              total: (data && data.total) || 0,
            };
          }),
      onSuccess: (results, total) => {
        this.setState({
          data: results,
          totalRecords: total,
          loader: false,
          isDataEmpty: !results || results.length === 0,
        });
      },
      onError: () => this.setState({ loader: false }),
    });
    attachReportServerSideDatasource(params, datasource, TransactionFilterObj, 'executaton_date');
  };

  BindGrid = () => {
    if (this.gridApi) {
      this.refreshGrid();
      return;
    }
    // SSRM datasource is attached in onGridReady; avoid a parallel
    // legacy fetch/setState race that leaves the grid on Please Wait...
    this.setState({ loader: false });
  };

    handleInputChange = (event) => {
        this.setState({ queryId: event.target.value });
        TransactionFilterObj.group_id = event.target.value;
        this.BindGrid();
    };

    fetchSuggestions = async () => {
        try {
            const result = fetch(`${process.env.REACT_APP_BASEURL}groups/search`, {
                method: "GET",
                withCredentials: true,
                headers: {
                    Authorization:
                        "Bearer " +
                        JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
                            .jwtToken,
                    "Content-Type": "application/json",
                },
            }
            );
            result
                .then((result) => {
                    result.json().then((resLocation) => {
                        this.setState({ groups: resLocation && resLocation.data })
                    })
                })
        } catch (error) {
            console.error("Error fetching groups:", error);
        }
    };

    render() {
        const {classes, t} = this.props;
        return (
            <div>
                {
                    this.state.loader ?
                        <div className={classes.spinner}>
                            <img className={classes.spinnerImage} src={spinner} alt="loading" />
                        </div> :
                        null
                }
<div className={classes.tableWrapper}>
                    <ILocalAGGrid
            columnDefs={[
              { field: 'store_name', headerName: t("Report.phiLogs.Store"), colId: 'store_name' },
              { field: 'operation', headerName: t("Report.purgeTrail.Operation"), colId: 'operation' },
              { field: 'purge_success_s3_count', headerName: t("Report.purgeTrail.TotalPassedDeletion"), colId: 'purge_success_s3_count' },
              { field: 'purge_failed_s3_count', headerName: t("Report.purgeTrail.TotalFailedDeletion"), colId: 'purge_failed_s3_count' },
              { field: 'purge_success_db_count', headerName: t("Report.purgeTrail.TotalPassedupdation"), colId: 'purge_success_db_count' },
              { field: 'purge_failed_db_count', headerName: t("Report.purgeTrail.TotalFailedupdation"), colId: 'purge_failed_db_count' },
              { field: 'total_processed_images', headerName: t("Report.purgeTrail.TotalProcessedEntries"), colId: 'total_processed_images' },
              { field: 'purge_status', headerName: t("Report.purgeTrail.Status"), colId: 'purge_status' },
              withDateColumnFilter({ field: 'executaton_date', headerName: t("Report.purgeTrail.ExecutionDate"), colId: 'executaton_date', valueFormatter: (p) => p.value ? this.convertToTimeZone(p.value) : '' }),
            ]}
            defaultColDef={getDefaultColDef()}
            rowModelType="serverSide"
            cacheBlockSize={TransactionFilterObj.pageSize || 10}
            paginationPageSize={TransactionFilterObj.pageSize || 10}
            paginationPageSizeSelector={[10, 20, 25]}
            rowHeight={40}
            getRowId={(params) =>
              (params.data && (params.data.prescription_txn_id || params.data.id || params.data.pmid || params.data.uuid)) ||
              String(params.data && JSON.stringify(params.data).slice(0,40))
            }
            onGridReady={this.onGridReady}
            onPaginationChanged={this.onPaginationChanged}
          />
        </div>
            </div>
        );
    }
}

PurgeTrailComponent.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(withTranslation()(PurgeTrailComponent));



// WEBPACK FOOTER //
// ./src/components/reports/purge-trail/index.js